import React from 'react';
import UserRegistration from '../../forms/UserRegistration/index';
import centredForm from '../components/centredForm';
import FormTitle from '../components/FormTitle';

export default centredForm(
  UserRegistration,
  <FormTitle title="registrationTitle" />,
  350
);



// WEBPACK FOOTER //
// ./src/view/scenes/Registration/UserRegistrationPage.js